module.exports = __webpack_public_path__ + "static/img/hcp-ladder-brintellix-3-invalid.7aa913cd.png";